import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { IClearFilterButtonProps } from './ClearFilterButton.interface';

export const ClearFilterButton: FunctionComponent<IClearFilterButtonProps> = ({ onClick, isShown }) => {
  const { t } = useTranslation();

  if (!isShown) {
    return null;
  }

  return (
    <IconButton
      onClick={onClick}
      size={'small'}
      color={'primary'}
      aria-label={t('text:common.button.clearSymbolFilter')}
      sx={{ p: 0, marginLeft: 'auto' }}
    >
      <FilterAltOffIcon />
    </IconButton>
  );
};
